import { Users, FileText, Camera, Shield, type LucideIcon } from 'lucide-react'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../contexts/AuthContext'
import { dashboardApi } from '../services/api/dashboard'

type StatKey = 'persons' | 'biodata' | 'photos' | 'media_release_forms'
const STAT_DEFS: Array<{ name: string; key: StatKey; icon: LucideIcon; tile: string }> = [
  { name: 'Total persons',      key: 'persons',              icon: Users,    tile: 'tile-info' },
  { name: 'Biodata entries',    key: 'biodata',              icon: FileText, tile: 'tile-bio' },
  { name: 'Photos',             key: 'photos',               icon: Camera,   tile: 'tile-photos' },
  { name: 'Media release forms',key: 'media_release_forms',  icon: Shield,   tile: 'tile-mrf' },
]

export default function DashboardPage() {
  const { user } = useAuth()

  const { data: stats, isLoading, isError } = useQuery({
    queryKey: ['dashboard-stats'],
    queryFn: () => dashboardApi.getStats(),
    staleTime: 60_000,
  })

  const formatNumber = (n: number) => n.toLocaleString()

  return (
    <div style={{ background: 'var(--bk-bg)', minHeight: '100%' }}>
      <section className="bk-page-hero">
        <h1 className="bk-page-title">Dashboard</h1>
        <p className="bk-page-sub">
          Welcome back{user?.display_name ? `, ${user.display_name}` : ''}. Here's a snapshot of your BK Profiles workspace.
        </p>
      </section>

      <div style={{ padding: '24px 32px 64px' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
            gap: 18,
          }}
        >
          {STAT_DEFS.map(def => {
            const Icon = def.icon
            return (
              <div key={def.key} className="bk-card bk-card-pad" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div style={{ width: 44, height: 44, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', color: 'var(--bk-muted)' }}>
                  <Icon size={22} strokeWidth={1.5} />
                </div>
                <div>
                  <div style={{ fontSize: 12.5, color: 'var(--bk-muted)', fontWeight: 500 }}>{def.name}</div>
                  <div
                    className="bk-display"
                    style={{ fontSize: 34, fontWeight: 600, color: 'var(--bk-ink)', marginTop: 4, fontVariantNumeric: 'tabular-nums' }}
                  >
                    {isLoading ? (
                      <span className="bk-skel" style={{ display: 'inline-block', height: 32, width: 80 }} />
                    ) : isError ? (
                      <span style={{ color: 'var(--bk-muted)' }}>—</span>
                    ) : (
                      formatNumber(stats?.[def.key] ?? 0)
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
